import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export default class NewBusinessOpenProcessRecordAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getNewBusinessOpenProcessList', {
      url: '/admin/opening/schemeList',
      name: 'list',
      label: '列表'
    }],
    ['addNewBusinessOpenProcess', {
      url: '/admin/opening/schemeAdd',
      name: 'add',
      label: '添加'
    }],
    ['updateNewBusinessOpenProcess', {
      url: '/admin/opening/schemeEdit',
      name: 'edit',
      label: '编辑'
    }],

    ['getChooseOpenBusinessProcessList', {
      url: '/admin/opening/planAll',
      name: 'choose-open-business-porceess-list',
      label: '可选开业进度列表'
    }]
    // ['deleteNewBusinessOpenProcess', {
    //   url: '/admin/operate_hint/delete',
    //   name: 'delete',
    //   label: '删除'
    // }],
    // ['searchVenueList', {
    //   url: '/admin/coupons/shop/list',
    //   name: 'shop-list',
    //   label: '店铺列表',
    //   // hidden: true
    // }],
   
  ])

  // 新厅开业进度列表
  public getNewBusinessOpenProcessList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getNewBusinessOpenProcessList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 修改新厅开业进度
  public updateNewBusinessOpenProcess(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('updateNewBusinessOpenProcess').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 添加新厅开业进度
  public addNewBusinessOpenProcess(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('addNewBusinessOpenProcess').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 可选开业进度列表
  public getChooseOpenBusinessProcessList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getChooseOpenBusinessProcessList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 删除新厅开业进度
  // public deleteNewBusinessOpenProcess(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deleteNewBusinessOpenProcess').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 搜索店铺列表
  // public searchVenueList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('searchVenueList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  
}